<template>
    <el-scrollbar :style="{height: winHeight}">
        <table class="bm-table" v-loading="loading">
            <!--<tr class="table-header">-->
                <!--<td colspan="2" style="text-align: center">Protein Information</td>-->
            <!--</tr>-->
            <tr>
                <td class="bm-table-name">Accession</td>
                <td class="bm-table-ope">
                    <p class="info-p">{{protein_res.accession}}
                            <a :href="`https://www.uniprot.org/uniprot/${protein_res.accession}`" target="_blank"><img title="UniProt Protein Database" alt="UniProt Protein Database" src="../../../public/img/uniprot_btn.png" style="height:20px; cursor: pointer; padding:0 0 0 5px"/></a>
                    </p>
                </td>
            </tr>
            <tr>
                <td class="bm-table-name">Organism</td>
                <td class="bm-table-ope" v-if="protein_res['organism'] !== undefined">
                    <p class="info-p">{{protein_res['organism']['names'][0]['value']}} ({{protein_res['organism']['names'][1]['value']}})
                        <a :href="`https://www.ncbi.nlm.nih.gov/Taxonomy/Browser/wwwtax.cgi?id=${protein_res['organism']['taxonomy']}`" target="_blank"><i class="icon-font icon-dianshang-wailian-77"></i></a>
                    </p>

                </td>
            </tr>
            <tr v-for="(comment, i) in protein_res['comments']" :key="i" >
                <td v-if="comment['type'] === 'FUNCTION'" class="bm-table-name">Function</td>
                <td v-if="comment['type'] === 'FUNCTION'" class="bm-table-ope">
                    <p class="info-p">
                        {{comment['text'][0]['value']}}
                        <!--<a :href="`https://www.uniprot.org/uniprot/${protein_res.accession}#function`" target="_blank"><i class="icon-font icon-dianshang-wailian-77"></i></a>-->
                    </p>
                </td>
                <td v-if="comment['type'] === 'SUBCELLULAR_LOCATION'" class="bm-table-name">Location</td>
                <td v-if="comment['type'] === 'SUBCELLULAR_LOCATION'" class="bm-table-ope">
                    <p class="info-p"  v-for="(location,j) in comment['locations']" :key="j">{{location['location']['value']}}</p>
                </td>
                <td v-if="comment['type'] === 'SIMILARITY'" class="bm-table-name">Similarity</td>
                <td v-if="comment['type'] === 'SIMILARITY'" class="bm-table-ope">
                    <p class="info-p" v-for="(simliarity_item, si) in comment['text']" :key="si">{{simliarity_item['value']}}
                        <!--<a v-if="simliarity_item['evidences'][0]['source'].hasOwnProperty('url')" :href="simliarity_item['evidences'][0]['source']['url']" target="_blank"><i class="icon-font icon-dianshang-wailian-77"></i></a>-->
                    </p>
                </td>
                <td v-if="comment['type'] === 'MISCELLANEOUS'" class="bm-table-name">Other</td>
                <td v-if="comment['type'] === 'MISCELLANEOUS'" class="bm-table-ope">
                    <p class="info-p"  v-for="(ele,j) in comment['text']" :key="j">{{ele['value']}}</p>
                </td>
                <td v-if="comment['type'] === 'WEBRESOURCE'" class="bm-table-name">Source</td>
                <td v-if="comment['type'] === 'WEBRESOURCE'" class="bm-table-ope">
                    <p class="info-p" >{{comment['value']}}
                        {{comment['name']}}: {{comment['text']}} <a :href="comment['url']" target="_blank"><i class="icon-font icon-dianshang-wailian-77"></i></a>
                    </p>
                </td>
            </tr>

            <!--<tr>-->

            <!--</tr>-->
        </table>
    </el-scrollbar>
</template>

<script>
    import axios from "axios";

    export default {
        name: "Protein",
        data() {
            return {
                protein_res: {},
                accession: "",
                winHeight: window.innerHeight - 90 + "px",
                loading: false,
            }
        },
        props: {
        },
        watch: {
            "$store.state.current_protein" (res){
                // console.log(res);
                this.accession = res['accession'];
                this.update_date();
            }
        },
        mounted (){
            this.init();
        },
        methods: {
            init() {

            },
            update_date() {
                let url = `https://www.ebi.ac.uk/proteins/api/proteins/${this.accession}`;
                // console.log(url);
                this.loading=true;
                axios.get(url).then((res) => {
                    this.protein_res = res.data;
                    // console.log(res.data);
                    this.loading=false;
                    this.$store.commit("proteinUniprotMutation", res.data);
                });
            }
        }
    }
</script>

<style scoped>
    .bm-table-name {
        padding: 5px 0 5px 0;
        width: 80px;
        text-align: center;
    }
    .info-p {
        margin: 2px 8px 2px 8px;
        text-align: justify;
        text-justify:inter-ideograph;
    }
</style>
